var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.5 19.411 1.995-4.911 10-10a.774.774 0 0 1 1.096 0l1.7 1.7a.774.774 0 0 1 0 1.097l-9.916 9.995z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.581 9H9v12h12v-7.956l2-2.019V21a2 2 0 0 1-2 2H9l-.204-.01A2 2 0 0 1 7 21V9a2 2 0 0 1 1.796-1.99L9 7h9.581z"
  })));
};
export default SvgEdit;